import HotelsByStarRating from './HotelsByStarRating';

export default HotelsByStarRating;
